/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatesNumberSuggestionResult
 */
export interface BatesNumberSuggestionResult {
    /**
     * 
     * @type {string}
     * @memberof BatesNumberSuggestionResult
     */
    prefix?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BatesNumberSuggestionResult
     */
    startingNumber?: number;
}

export function BatesNumberSuggestionResultFromJSON(json: any): BatesNumberSuggestionResult {
    return BatesNumberSuggestionResultFromJSONTyped(json, false);
}

export function BatesNumberSuggestionResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatesNumberSuggestionResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'prefix': !exists(json, 'prefix') ? undefined : json['prefix'],
        'startingNumber': !exists(json, 'startingNumber') ? undefined : json['startingNumber'],
    };
}

export function BatesNumberSuggestionResultToJSON(value?: BatesNumberSuggestionResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'prefix': value.prefix,
        'startingNumber': value.startingNumber,
    };
}


